import * as React from "react";
import type { SVGProps } from "react";
const AutoRepair = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_661)">
      <g clipPath="url(#clip1_4362_661)">
        <path
          fill="currentColor"
          d="M7.5992 2.6997c-.2475 0-.465.15-.5588.3788L5.938 5.8535l-2.8537-.87a.603.603 0 0 0-.645.1987c-.1538.1913-.1725.4575-.0525.6713L3.868 8.4447l-2.46 1.695a.594.594 0 0 0-.2437.6263c.0562.24.2512.42.4912.4575l2.9513.4575-.21 2.9812a.595.595 0 0 0 .3375.5813.608.608 0 0 0 .6675-.0975l1.3237-1.2188.3563-1.3275.39-1.4475A3.287 3.287 0 0 1 9.643 8.8685l1.5375-2.22a4.227 4.227 0 0 1 1.6313-1.395c-.015-.0225-.03-.045-.0488-.0675a.603.603 0 0 0-.645-.1988l-2.8575.8663-1.1025-2.775c-.0937-.2288-.3112-.3788-.5587-.3788M14.788 8.456l5.085 1.3612c.2438.0675.4238.2775.4425.5325l.1725 2.1188-7.5562-2.025 1.2075-1.7475c.1425-.21.405-.3038.6487-.24m-2.6212-1.125-1.7963 2.5987a2.097 2.097 0 0 0-1.7362 1.5375l-.39 1.4475-.6225 2.3175-.3113 1.1588c-.1725.6412.21 1.2975.8475 1.47l.5813.1537c.6412.1725 1.2975-.21 1.47-.8475l.3112-1.1587 9.2738 2.4862-.3113 1.1588c-.1725.6412.21 1.2975.8475 1.47l.5813.1537c.6412.1725 1.2975-.21 1.47-.8475l.3112-1.1587.6188-2.3213.39-1.4475c.225-.84-.0938-1.695-.735-2.2012l-.255-3.15c-.1013-1.2638-.99-2.325-2.2125-2.655l-5.0925-1.3575c-1.2263-.33-2.5238.15-3.2438 1.1925zm-.6375 4.9125a.8995.8995 0 0 1 .6602.7518.902.902 0 0 1-.1779.6659.9005.9005 0 1 1-.4823-1.4177m8.1712 3.12a.9.9 0 1 1 1.7363.465.901.901 0 0 1-.7519.6602.9.9 0 0 1-.6659-.1779.902.902 0 0 1-.345-.5967.9.9 0 0 1 .0228-.3506z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4362_661">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4362_661">
        <path fill="transparent" d="M1 2.3999h24v19.2H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default AutoRepair;
